/* World Kitchen Designs section helpers. Safe to include more than once. */
(function () {
  'use strict';
  if (window.__wkdInit) return;
  window.__wkdInit = true;
  var dl = (window.dataLayer = window.dataLayer || []);

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* Google Tag Manager: click-to-call from World Kitchen Designs sections */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-wkd-call]');
      if (a) dl.push({ event: 'wkd_click_to_call', link_text: (a.textContent || '').trim(), page_path: location.pathname });
    });

    /* Consultation form: success event, focus, and required-field check */
    var ok = document.querySelector('[data-wkd-form-success]');
    if (ok) { dl.push({ event: 'wkd_consultation_request', page_path: location.pathname }); ok.focus(); }
    var err = document.querySelector('[data-wkd-form-error]');
    if (err) err.focus();
    var form = document.getElementById('WkdConsultForm');
    if (form && form.tagName === 'FORM') {
      form.addEventListener('submit', function (e) {
        var invalid = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (f) {
          var bad = !f.value.trim() || (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value)) || (f.pattern && !new RegExp('^(?:' + f.pattern + ')$').test(f.value.trim()));
          f.setAttribute('aria-invalid', bad ? 'true' : 'false');
          return bad;
        });
        var box = form.querySelector('[data-wkd-client-error]');
        if (invalid.length) { e.preventDefault(); if (box) box.hidden = false; invalid[0].focus(); }
        else if (box) { box.hidden = true; }
      });
    }

    /* Video stories: load the player only when someone presses play */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wkd-vcard__play');
      if (!btn) return;
      var frame = btn.closest('[data-wkd-video]');
      var tpl = frame && frame.querySelector('template');
      if (!tpl) return;
      var node = tpl.content.cloneNode(true);
      frame.innerHTML = '';
      frame.appendChild(node);
      var v = frame.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); v.focus(); }
    });
  });
})();
